import React from 'react';
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function AirQuality() {

  const navigate = useNavigate();
  const [statedata, setStateData] = useState(useLocation().state)

  const goBack = () => {
    navigate(-1);
  }
  return (
    <>

      <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          <h1 className="h2 arrow-and-title">
            <Link onClick={goBack}>
              <i className="fa-solid fa-arrow-left"></i>
            </Link>
            <h1 className="h2"> Air Quality </h1>
          </h1>

        </div>
        <div>Air Quality</div>
      </main>
    </>
  )
}
